/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_R10_PurposeInputs */

const tr_cerez_s3_r10_purpose = /** @type {(inputs: Cerez_S3_R10_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dili bu tarayıcıda kendiniz seçtiğinizin işareti; hesabınızdaki dil bu seçimin üzerine yazılmaz (yerel depolama)`)
};

const en_cerez_s3_r10_purpose = /** @type {(inputs: Cerez_S3_R10_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marks that you chose the language in this browser yourself, so the language saved in your account does not overwrite it (local storage)`)
};

const de_cerez_s3_r10_purpose = /** @type {(inputs: Cerez_S3_R10_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkt, dass Sie die Sprache in diesem Browser selbst gewählt haben, damit die im Konto gespeicherte Sprache sie nicht überschreibt (lokaler Speicher)`)
};

const ru_cerez_s3_r10_purpose = /** @type {(inputs: Cerez_S3_R10_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмечает, что вы сами выбрали язык в этом браузере, чтобы язык из учётной записи его не перезаписывал (локальное хранилище)`)
};

/**
* | output |
* | --- |
* | "Marks that you chose the language in this browser yourself, so the language saved in your account does not overwrite it (local storage)" |
*
* @param {Cerez_S3_R10_PurposeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_r10_purpose = /** @type {((inputs?: Cerez_S3_R10_PurposeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_R10_PurposeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_r10_purpose(inputs)
	if (locale === "de") return de_cerez_s3_r10_purpose(inputs)
	if (locale === "ru") return ru_cerez_s3_r10_purpose(inputs)
	return tr_cerez_s3_r10_purpose(inputs)
});